//
//
//
//
//
//
//
//

export default {
  name: 'VSpacer',
}
